import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import ModalCardSens from '../components/DetailModal/MeaningDetailModal';
import { appLanguage } from '@orientaction/reducers';
import { publicSvgPath, resultatWithColor } from '@orientaction/utils';
import { take } from 'lodash';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import MeaningResultPodium from '../components/MeaningResultPodium';
import ResultDetailCard from '../components/ResultDetailCard';
import {
  DetailsSection,
  SummaryCard,
  SummaryGrid,
  SummarySideCards,
} from '../components/SummarySection';
import { useMajorResultStyles } from '../MajorResult.styles';
import { MajorTestContentProps } from '../types';
import { useMeaningContentStyles } from './MeaningContent.styles';
import { meaningImages, meaningRankColors } from './meaningPresentation';

const getSensImage = (key: string, lang: string) => {
  const enMap: Record<string, string> = {
    compliance: 'en_compliance.png',
    universalism: 'en_UNIVERSALISME_carte.png',
    hedonism: 'en_HEDONISME_carte.png',
    achievement: 'en_REUSSITE_carte.png',
    stimulation: 'en_STIMULATION_carte.png',
    tradition: 'en_TRADITION_carte.png',
    kindness: 'en_BIENVEILLANCE_carte.png',
    security: 'en_SECURITE_carte.png',
    power: 'en_POUVOIR_carte.png',
    autonomy: 'en_AUTONOMIE_carte.png',
  };

  if (lang !== 'FR') {
    return `${publicSvgPath}/${enMap[key] || ''}`;
  }

  return `${publicSvgPath}/${resultatWithColor[key]?.img || ''}`;
};

const MeaningContent: FC<MajorTestContentProps> = ({ myResult }) => {
  const shared = useMajorResultStyles();
  const local = useMeaningContentStyles();
  const classes = { ...shared, ...local };
  const lang: string = useSelector(appLanguage);
  const results = myResult?.resultat || [];
  const topThree = take(results, 3);

  const [modalState, setModalState] = useState<{ open: boolean; sens: any | null }>({
    open: false,
    sens: null,
  });

  return (
    <>
      <SummaryGrid>
        <SummaryCard title="SYNTHÈSE DE VOS RÉSULTATS">
          <MeaningResultPodium results={topThree} />
          <p className={classes.footnote}>
            *en cas d&apos;égalité de scores l&apos;une des valeurs est mise en premier
            automatiquement
          </p>
        </SummaryCard>

        <SummarySideCards>
          <SummaryCard title="DÉCOUVREZ VOS VALEURS">
            <p>
              Voici vos valeurs directrices. Vos valeurs directrices guident vos pensées et vos
              comportements. Elles sont à la source du sens que vous donnez à vos actions. Agir
              conformément à vos valeurs vous permettra de développer votre motivation et votre
              bien-être. Vous vous sentirez aligné(e) entre ce que vous êtes et ce que vous faites.
            </p>
          </SummaryCard>
          <SummaryCard title="APPLICATION DANS VOTRE VIE PRO ET PERSO">
            <p>
              Dans votre vie professionnelle, vous devriez exercer un métier cohérent avec vos
              valeurs et travailler dans une organisation qui vous permet de les exprimer à travers
              vos actions. Dans votre vie personnelle, vous devriez développer des relations avec
              des personnes qui partagent vos valeurs. Développer des relations avec des personnes
              qui ont la même vision de la vie que vous favorise la bonne entente et l’harmonie.
            </p>
          </SummaryCard>
        </SummarySideCards>
      </SummaryGrid>

      <DetailsSection title="DÉCOUVREZ VOS 3 VALEURS PRINCIPALES">
        {topThree.map((sens: any, index: number) => {
          const color = meaningRankColors[index];
          const imageSrc = meaningImages[sens.key] || getSensImage(sens.key, lang);

          return (
            <ResultDetailCard
              key={sens.key}
              label={sens.label}
              color={color}
              labelColor="#FFFFFF"
              imageSrc={imageSrc}
              imageAlt={sens.label}
              title={sens.description?.[0]}
              subtitle={sens.description?.[1]}
              onLearnMore={() => setModalState({ open: true, sens })}
              imageOverlay={
                <div className={classes.scoreBadge}>
                  <CircularProgressCustom
                    value={sens.score}
                    color={color}
                    size={98}
                    fontSize={18}
                    fontSizeFloat={12}
                  />
                </div>
              }
            />
          );
        })}
      </DetailsSection>

      {modalState.sens && (
        <ModalCardSens
          open={modalState.open}
          onCancel={() => setModalState({ open: false, sens: null })}
          color={
            meaningRankColors[topThree.findIndex((sens: any) => sens.key === modalState.sens.key)]
          }
          img={meaningImages[modalState.sens.key] || getSensImage(modalState.sens.key, lang)}
          sens={modalState.sens}
          colorSecondary={resultatWithColor[modalState.sens.key]?.colorSecondary}
          opacity={!!resultatWithColor[modalState.sens.key]?.opacity}
          longText={resultatWithColor[modalState.sens.key]?.longText}
          text1={resultatWithColor[modalState.sens.key]?.text1}
          listeAccordeon={resultatWithColor[modalState.sens.key]?.listeAccordeon}
          listEmploi1={resultatWithColor[modalState.sens.key]?.listEmploi1}
          listEmploi2={resultatWithColor[modalState.sens.key]?.listEmploi2}
          text2={resultatWithColor[modalState.sens.key]?.text2}
          text3={resultatWithColor[modalState.sens.key]?.text3}
          text4={resultatWithColor[modalState.sens.key]?.text4}
        />
      )}
    </>
  );
};

export default MeaningContent;
